import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bowser from 'bowser';
import { compose, branch, withProps } from 'recompose';

import { SUPPORTED_BROWSER_VERSIONS } from 'config';
import { hasAdBlocker } from 'selectors/adBlocker';
import { isUserInSupportedRegion } from 'selectors/auth';
import { getIsOnline } from 'selectors/network';

import OfflineAlert from './Alerts/OfflineAlert';
import AdBlockerAlert from './Alerts/AdBlockerAlert';
import BrowserSupportAlert from './Alerts/BrowserSupportAlert';
import RegionSupportAlert from './Alerts/RegionSupportAlert';
import AlertBar from './common/AlertBar';

/**
 * IF YOU WANT TO ALERT TO ALL USERS:
 * 1. update our alert.txt file in S3 and set the permissions to allow access:
 *    https://s3.amazonaws.com/voltron-ui/alert/alert.txt.
 *    Instructions: https://confluence.spotify.net/display/CREAM/AdStudio+Admin+Alerting
 * 2. if S3 is down, you can set a value in the ADMIN_ALERT_OVERRIDE constant below to
 *    provide an admin alert from the code.
 * If both an alert.txt and the constant in code are set, the constant will win.
 */

const ADMIN_ALERT_OVERRIDE = null;

export const GlobalAlerts = ({
  adBlockerDetected,
  adminAlertText,
  isOffline,
  showBrowserSupportAlert,
  isUnsupportedRegion,
}) => (
  <div className="global-alert-container">
    { isOffline && <OfflineAlert /> }
    { adBlockerDetected && <AdBlockerAlert /> }
    { showBrowserSupportAlert && <BrowserSupportAlert /> }
    { isUnsupportedRegion && <RegionSupportAlert /> }
    { !!adminAlertText && (
      <AlertBar alertType="warning">
        { adminAlertText }
      </AlertBar>
    ) }
  </div>
);

GlobalAlerts.propTypes = {
  adBlockerDetected: PropTypes.bool,
  adminAlertText: PropTypes.string,
  isOffline: PropTypes.bool,
  isUnsupportedRegion: PropTypes.bool,
  showBrowserSupportAlert: PropTypes.bool,
};

GlobalAlerts.defaultProps = {
  showBrowserSupportAlert: !bowser.check(SUPPORTED_BROWSER_VERSIONS) || bowser.mobile,
};

function mapStateToProps(state) {
  return {
    adBlockerDetected: hasAdBlocker(state),
    adminAlertText: state.adminAlert.text,
    isOffline: !getIsOnline(state),
    isUnsupportedRegion: !isUserInSupportedRegion(state),
  };
}

export default compose(
  connect(mapStateToProps),
  // if you set ADMIN_ALERT_OVERRIDE above, use the value from it instead of the
  // value from alert.txt on S3 to supply an error.
  branch(
    () => ADMIN_ALERT_OVERRIDE,
    withProps({ adminAlertText: ADMIN_ALERT_OVERRIDE })
  ),
)(GlobalAlerts);



// WEBPACK FOOTER //
// ./src/components/GlobalAlerts.js